import { Observable } from "rxjs";
import { filter } from "rxjs/operators";

type TruthyOf<T> = T extends false
	? never
	: T extends boolean
		? true
		: T extends 0
			? never
			: T extends ""
				? never
				: T extends null
					? never
					: T extends undefined
						? never
						: T;

/**
 * A filter which removes falsy values. The filter will also narrow to the equivalent truthy value where possible.
 *
 * ```ts
 * this.store.pipe(select(this.selector.isBusy), ignoreFalsy())
 * ```
 *
 * @return An Observable that only emits truthy values.
 */
export const ignoreFalsy =
	() =>
	<T>(source: Observable<T>) =>
		source.pipe(filter((input) => !!input)) as Observable<TruthyOf<T>>;
